import type { ProxyPhone } from "@remi/types/proxy";

export const getProxyPhoneRowKey = (proxyPhone: ProxyPhone) =>
  `${proxyPhone.id}-${proxyPhone.contractorOrg?.id ?? "legacy"}`;

export const appendProxyOrgLabel = (formattedProxyNumber: string, orgName?: string) =>
  orgName ? `${formattedProxyNumber} (${orgName})` : formattedProxyNumber;

interface GroupedProxyPhones {
  primaryProxies: ProxyPhone[];
  getProxiesForPhoneId: (phoneId: string) => ProxyPhone[];
}

export const groupProxyPhonesForDisplay = (input: {
  proxyPhones: ProxyPhone[];
  primaryPhoneId?: string | null;
}): GroupedProxyPhones => {
  const { proxyPhones, primaryPhoneId } = input;

  const primaryProxies = primaryPhoneId
    ? proxyPhones.filter((proxyPhone) => proxyPhone.phoneId === primaryPhoneId)
    : [];

  return {
    primaryProxies,
    getProxiesForPhoneId: (phoneId: string) =>
      phoneId === primaryPhoneId ? [] : proxyPhones.filter((proxyPhone) => proxyPhone.phoneId === phoneId),
  };
};
